import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [showSpecs, setShowSpecs] = useState(false);
  const [showDescription, setShowDescription] = useState(false);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, quantity, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    let stars = "";
    
    for (let i = 0; i < fullStars; i++) {
      stars += "★";
    }
    for (let i = fullStars; i < 5; i++) {
      stars += "☆";
    }
    return stars;
  };

  const getBrandName = () => {
    return "slayfulpawsco";
  };

  return (
    <div className="product-detail">
      <main className="product-detail__main">
        <div className="product-detail__content">
          <div className="product-detail__left">
            <div className="product-detail__thumbnails">
              {product.images.map((img, idx) => (
                <div 
                  key={idx}
                  className={`product-detail__thumbnail ${selectedImage === idx ? 'active' : ''}`}
                  onClick={() => setImage(idx)}
                >
                  <img src={img} alt={`${product.name} ${idx + 1}`} />
                </div>
              ))}
            </div>
            <div className="product-detail__main-image">
              <img src={product.images[selectedImage]} alt={product.name} />
            </div>
          </div>

          <div className="product-detail__right">
            <div className="product-detail__header">
              <span className="product-detail__new-badge">New</span>
              <h1 className="product-detail__title">{product.name}</h1>
              <p className="product-detail__brand">
                by <span>{getBrandName()}</span>
              </p>
              <p className="product-detail__price">${product.price}</p>
              <p className="product-detail__shipping">Shipping calculated at checkout.</p>
              
              {product.reviews !== "0" && (
                <div className="product-detail__rating">
                  <span className="stars">{renderStars(product.rating)}</span>
                  <span className="review-count">{product.reviews} review{product.reviews !== "1" ? 's' : ''}</span>
                </div>
              )}

              {product.colors && product.colors.length > 0 && (
                <div className="product-detail__options">
                  <p className="product-detail__option-label">Color:</p>
                  <div className="product-detail__colors">
                    {product.colors.map((color, idx) => (
                      <button
                        key={idx}
                        className={`product-detail__option-btn ${selectedColor === color ? 'active' : ''}`}
                        onClick={() => setSelectedColor(color)}
                      >
                        {color}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {product.size && product.size.length > 0 && (
                <div className="product-detail__options">
                  <p className="product-detail__option-label">Size:</p>
                  <div className="product-detail__sizes">
                    {product.size.map((size, idx) => (
                      <button
                        key={idx}
                        className={`product-detail__option-btn ${selectedSize === size ? 'active' : ''}`}
                        onClick={() => setSelectedSize(size)}
                      >
                        {size}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              <div className="product-detail__quantity">
                <p className="product-detail__option-label">Quantity</p>
                <div className="quantity-controls">
                  <button 
                    className="quantity-btn"
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  >−</button>
                  <span className="quantity-value">{quantity}</span>
                  <button 
                    className="quantity-btn"
                    onClick={() => setQuantity(quantity + 1)}
                  >+</button>
                </div>
              </div>

              <button 
                className="product-detail__add-to-cart"
                onClick={handleAddToCart}
              >
                Add to Cart
              </button>

            
            </div>

            <div className="product-detail__sections">
              <div className="product-detail__section">
                <button 
                  className="product-detail__section-toggle"
                  onClick={() => setShowDescription(!showDescription)}
                >
                  <span className="section-title">Description</span>
                  <span className="section-icon">{showDescription ? '↑' : '↓'}</span>
                </button>
                {showDescription && (
                  <div className="product-detail__section-content">
                    {product.description.map((paragraph, idx) => (
                      <p key={idx}>{paragraph}</p>
                    ))}
                  </div>
                )}
              </div>

              <div className="product-detail__section">
                <button 
                  className="product-detail__section-toggle"
                  onClick={() => setShowSpecs(!showSpecs)}
                >
                  <span className="section-title">Specifications</span>
                  <span className="section-icon">{showSpecs ? '↑' : '↓'}</span>
                </button>
                {showSpecs && (
                  <div className="product-detail__section-content">
                    <div className="specs-list">
                      {product.Features.map((feature, idx) => {
                        const [label, value] = feature.split(': ');
                        return (
                          <div key={idx} className="spec-item">
                            <span className="spec-label">{label}:</span>
                            <span className="spec-value">{value}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ProductDetail;
